<template>
  <section class="document-category-section mb-8">
    <h2 class="section-heading mb-4">{{ name }}</h2>
    <template v-for="entry in entries">
      <OtherDocumentsList
        v-if="isOtherType(entry)"
        :key="entry.type"
        :viewed-testator-id="viewedTestatorId"
        :entry="entry"
        @refetch="$emit('refetch')"
        @deleted="payload => $emit('deleted', payload)"
      />
      <component
        :is="
          entry.multiInstance ? 'DocumentMultiCard' : 'DocumentPlaceholderCard'
        "
        v-else
        :key="entry.type"
        :viewed-testator-id="viewedTestatorId"
        :category="entry"
        :documents="entry.documents"
        @refetch="$emit('refetch')"
        @deleted="payload => $emit('deleted', payload)"
      />
    </template>
  </section>
</template>

<script>
  import DocumentPlaceholderCard from './DocumentPlaceholderCard.vue';
  import DocumentMultiCard from './DocumentMultiCard.vue';
  import OtherDocumentsList from './OtherDocumentsList.vue';

  const OTHER_TYPE = 'TestatorDocuments::Other';

  export default {
    name: 'DocumentCategorySection',
    components: {
      DocumentPlaceholderCard,
      DocumentMultiCard,
      OtherDocumentsList,
    },
    props: {
      viewedTestatorId: { type: [Number, String], required: true },
      name: { type: String, required: true },
      entries: { type: Array, required: true },
    },
    methods: {
      isOtherType(entry) {
        return entry.type === OTHER_TYPE;
      },
    },
  };
</script>

<style scoped>
  .section-heading {
    color: #282828;
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    margin-top: 0;
  }
</style>
